/* eslint-disable */
export default [
  {
    id: 5,
    customerId: '0001000001',
    name: 'Sandro Devos',
    email: 'sandro.devos@delaware.pro',
    isActive: true,
  },
  {
    id: 6,
    customerId: '0001000001',
    name: 'Rens Bonnez',
    email: 'rens.bonnez@delaware.pro',
    isActive: false,
  },
];
